import type { Resources } from './en';

const pt: Resources = {
  nav: {
    home: 'Início do MixGenie',
    appNav: 'Navegação do app',
    signIn: 'Entrar',
    signUp: 'Criar conta',
    install: 'Instalar',
    micAttached: 'Gravação anexada como referência',
  },
  common: {
    cancel: 'Cancelar',
    save: 'Salvar',
    close: 'Fechar',
  },
  settings: {
    title: 'Ajustes',
    theme: 'Tema',
    themeAuto: 'Auto',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    language: 'Idioma',
    tutorial: 'Tutorial',
    tutorialCta: 'Me mostre o app',
    tutorialToastTitle: 'Tour guiado',
    tutorialToastBody: 'O tutorial chega na próxima versão — enquanto isso, solte uma Referência, escolha um Preset e toque no botão ↑.',
    buildLabel: 'Build',
    iconsCredit: 'Ícones: Solar por 480 Design, licenciados CC BY 4.0',
    linkSupport: 'Suporte',
    linkPrivacy: 'Política de privacidade',
    linkTerms: 'Termos',
    linkRefund: 'Política de reembolso',
  },
  languages: {
    en: 'Inglês',
    es: 'Espanhol',
    pt: 'Português',
  },
  footer: {
    about: 'Sobre',
    contact: 'Contato',
    help: 'Central de ajuda ↗',
    terms: 'Termos e condições',
    privacy: 'Privacidade e cookies',
  },
  composer: {
    emptyTitle: 'Crie uma música',
    emptySub: 'Comece com uma ideia, uma referência ou um preset.',
    typeIdea: 'Escrever uma ideia',
    uploadReference: 'Enviar referência',
    pickPreset: 'Escolher um preset',
    mySongs: 'Minhas músicas',
    orType: 'ou é só escrever abaixo — tudo bem começar sem nada.',
    composingTitle: 'Compondo sua música…',
    composingSub: 'Letra · voz · arranjo · capa. Costuma levar 2–4 min.',
    describePlaceholder: 'Descreva sua música — ex.: "indie pop melancólico sobre um domingo chuvoso"',
    lyricsPlaceholder: 'Cole sua letra aqui (opcional). Deixe em branco e o MixGenie escreve.',
    reference: 'Referência',
    presets: 'Presets',
    lyricsOff: '+ Letra',
    lyricsOn: 'Letra',
    instrumental: 'Instrumental',
    generating: 'Gerando…',
    pricePerSong: '1 crédito por música',
    signInFree: 'Entrar · 2 grátis',
    generateAria: 'Gerar',
    draftLyrics: 'Rascunhar letra do prompt',
    drafting: 'Rascunhando…',
  },
  share: {
    cta: 'Compartilhar',
    text: 'Ouça "{{title}}" — feita com o MixGenie',
    pickApp: 'Compartilhar em',
    device: 'Compartilhar…',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
  },
  generator: {
    title: 'Crie sua música',
    workingAria: 'Gerando sua música',
    cancel: 'Cancelar',
    refSearchPlaceholder: 'Busque uma música para usar como base…',
    refSearchEmpty: 'Sem resultados. Tente outro título ou artista.',
    refSearchExternal: 'Do Genius / iTunes — importada ao escolher',
    imageTooLarge: 'Imagem grande demais (máx. 12 MB)',
    inspireDone: 'Briefing da música criado a partir da imagem',
    inspireFail: 'Não foi possível interpretar a imagem',
    inspireBusy: 'Lendo a imagem…',
    inspireCtaShort: 'Crie uma música a partir de uma foto',
    inspireReading: 'MixGenie vê',
    referenceAttached: 'Referência anexada',
    referenceLabel: 'Música de referência',
    referenceHintShort: 'Opcional — busque, escolha ou grave uma faixa como referência.',
    referenceUsingLocal: 'Usando seu arquivo como semente de áudio',
    pickDeviceFile: 'Escolher do dispositivo',
    recordMic: 'Gravar com o microfone',
    micAttached: 'Gravação anexada como referência',
    untitled: 'Música do MixGenie',
    generateAnother: 'Gerar outra',
    working: 'Gerando…',
    needBase: 'Adicione um prompt ou uma referência',
    needLyrics: 'Adicione letra ou marque Instrumental',
    needPromptOrReference: 'Adicione um prompt ou uma música de referência para gerar.',
    generate: 'Gerar música',
    lyricsDraftEmpty: 'Não deu para rascunhar a letra — tente adicionar um prompt ou um tema.',
    lyricsDraftFailed: 'Falha ao rascunhar',
    tooFast: 'Opa — espere alguns segundos antes de gerar de novo.',
    failed: 'A geração falhou. Tente de novo.',
    newBrief: 'Novo',
    promptLabel: 'Prompt',
    addSoundPreset: 'Adicionar estilo / instrumento',
    promptPlaceholder: 'ex.: Synth-wave sombrio com baixo marcante, clima cinematográfico, produção dos anos 2020',
    lyricsLabel: 'Letra',
    addLyricTheme: 'Adicionar tema da letra',
    lyricsLanguageLabel: 'Idioma',
    draftLyrics: 'Rascunhar letra',
    instrumental: 'Só instrumental',
    instrumentalOn: 'Instrumental selecionado — letra desativada.',
    lyricsPlaceholder: 'Escreva ou cole a letra aqui. Toque em ✨ Rascunhar letra para o MixGenie sugerir uma.',
    jobFailed: 'Falha ao gerar',
    done: 'Pronto',
    viewAll: 'Minhas músicas',
    nowPlaying: '🎵 Tocando no player de baixo — use para pausar, buscar e controlar o volume.',
    download: 'Baixar',
    withCoverShort: '+ Capa',
    paywallTitle: 'Seus créditos acabaram',
    paywallBody: 'Compre um pacote de créditos ou assine para continuar gerando.',
    pw1: 'Geração de músicas ilimitada',
    pw2: 'Fila prioritária',
    pw3: 'Downloads em HD',
    seePlans: 'Ver planos',
    queueFullTitle: 'Você já tem músicas na fila',
    queueFullBody: 'Planos grátis permitem {{limit}} gerações ao mesmo tempo. Espere alguma terminar — ou faça upgrade para rodar várias em paralelo.',
    queueFullBodyGeneric: 'Espere alguma terminar — ou faça upgrade para rodar várias em paralelo.',
    qf1: 'Pule a fila do plano grátis',
    qf2: 'Várias gerações em paralelo',
    qf3: 'Processamento prioritário',
    queueFullWait: 'Vou esperar',
    queueFullUpgrade: 'Upgrade',
  },
  genOverlay: {
    push: {
      done: 'Avisamos assim que estiver pronta ✓',
      prompt: 'Quer um aviso quando terminar?',
      yes: 'Sim',
      no: 'Agora não',
    },
  },
  credits: {
    checkoutSuccess: 'Pagamento recebido — seus créditos estão atualizando.',
    checkoutCancelled: 'Pagamento cancelado.',
  },
  history: {
    title: 'Minhas músicas',
    untitled: 'Sem título',
    loadError: 'Falha ao carregar suas músicas.',
    empty: 'Você ainda não criou nenhuma música.',
    emptyPlaylist: 'Esta playlist está vazia. Adicione músicas em Todas as músicas.',
    emptyCta: 'Crie sua primeira música',
    playlistCreated: 'Playlist criada — música adicionada',
    playlistCreateFail: 'Não deu para criar a playlist',
    favFail: 'Não deu para atualizar — tente de novo',
    linkCopied: 'Link copiado',
    downloadFailed: 'Falha ao baixar',
    lyricsCopied: 'Letra copiada',
    lyricsCopyFail: 'Falha ao copiar — selecione o texto manualmente',
    failedArt: 'Esta geração falhou',
    unavailable: 'Indisponível',
    processing: 'Gerando…',
    share: 'Compartilhar',
    rename: 'Renomear',
    viewLyrics: 'Ver letra',
    generateSimilar: 'Gerar parecida',
    openStudio: 'Abrir no Studio',
    download: 'Baixar',
    playlists: 'Playlists',
    newPlaylistFromSong: 'Nova playlist com esta música',
    noPlaylists: 'Ainda sem outras playlists.',
    confirmDelete: 'Excluir "{{title}}"? Isso apaga a música e o áudio para sempre.',
    deleted: 'Música excluída',
    delete: 'Excluir música',
    renameTitle: 'Renomear música',
    renameLabel: 'Título da música',
    lyricsFor: 'Letra',
    copyLyrics: 'Copiar',
    newSongWithLyrics: 'Nova música com esta letra',
    playlistNameLabel: 'Nome da playlist',
    playlistNamePlaceholder: 'ex.: Vibes relax',
    playlistCreateAndAdd: 'Criar e adicionar',
  },
  player: {
    coverDone: 'Capa gerada — atualizando…',
    coverFail: 'Falha ao gerar a capa — tente de novo',
    coverTooLarge: 'Imagem grande demais (máx. 12 MB)',
    coverUploaded: 'Capa atualizada',
    coverUploadFail: 'Falha no envio — tente de novo',
    coverPainting: 'Pintando a capa com pictools.ai…',
    coverCta: 'Gerar capa com pictools.ai',
    coverCost: '1 crédito',
    coverUploading: 'Enviando a capa…',
    coverUploadCta: 'Enviar do dispositivo / câmera',
    linkCopied: 'Link copiado',
    confirmDelete: 'Excluir "{{title}}"? Isso apaga a música para sempre.',
    deleted: 'Música excluída',
    menuShare: 'Compartilhar',
    menuDownload: 'Baixar',
    menuRename: 'Renomear',
    menuGenerateSimilar: 'Gerar parecida',
    menuMakeVideo: 'Criar vídeo',
    menuDelete: 'Excluir',
    renameTitle: 'Renomear música',
    renameLabel: 'Título da música',
  },
  userMenu: {
    signedInAs: 'Logado como',
    anonymous: 'Usuário',
    mySongs: 'Minhas músicas',
    library: 'Biblioteca de músicas',
    credits: 'Créditos',
    themeLight: 'Tema claro',
    themeDark: 'Tema escuro',
    help: 'Ajuda e suporte ↗',
    signOut: 'Sair',
  },
  push: {
    label: 'Notificações',
    title: 'Me avise quando uma música estiver pronta',
    blocked: 'As notificações estão bloqueadas nas configurações do navegador para este site. Ative na barra de endereço (ícone de cadeado) → Permissões.',
    subscribed: 'Você está inscrito neste dispositivo. Desative para parar.',
    pitch: 'Receba um aviso no momento em que sua música terminar — sem precisar manter a aba aberta.',
    toggle: 'Ativar / desativar notificações',
    openSettings: 'Abrir as configurações de notificação do navegador',
  },
  invite: {
    title: 'Convide amigos, ganhe créditos',
    subtitle: 'Vocês dois recebem {{r}} créditos quando se cadastrarem{{p}}.',
    subtitlePurchase: ' — e mais {{n}} quando comprarem o primeiro pacote',
    subtitleReferrerOnly: 'Ganhe {{n}} créditos sempre que um amigo se cadastrar pelo seu link.',
    shareTitle: 'Faça músicas com o MixGenie',
    shareText: 'Entra no MixGenie comigo — os dois ganhamos {{n}} créditos grátis.',
    shareTextNoBonus: 'Entra no MixGenie comigo — gerador de músicas grátis.',
    copied: 'Link de convite copiado',
    copyFailed: 'Não deu para copiar — segure o link para compartilhar manualmente',
    codeCopied: 'Código copiado',
    copyCode: 'Copiar código',
    linkCopied: 'Link copiado ✓',
    share: 'Compartilhe seu link de convite',
    statsInvites: '{{n}} entraram',
    statsEarned: 'ganhos',
  },
  video: {
    eyebrow: 'Criar vídeo',
    formatLabel: 'Formato',
    styleLabel: 'Fundo',
    styleRandom: 'Aleatório',
    styleRandomHint: 'Um visual diferente a cada render — ótimo para soltar variações sem pensar muito.',
    watermark: 'Mostrar marca-d\'água do mixgenie.ai',
    karaoke: 'Letra karaokê (sincronização estimada)',
    karaokeHint: 'O timing por linha é estimado pela duração da música — costuma ficar a um ou dois tempos do real.',
    karaokeSynced: 'Letra karaokê (palavra a palavra)',
    karaokeSyncedHint: 'Timing palavra a palavra do provedor — acerta cada sílaba.',
    karaokeNoLyrics: 'Esta música não tem letra registrada.',
    rendering: 'Renderizando em tempo real — a música vai tocar uma vez do começo ao fim.',
    ready: 'O vídeo está pronto — toque em Baixar para salvar.',
    cancel: 'Parar',
    render: 'Renderizar vídeo',
    renderAgain: 'Renderizar de novo',
    download: 'Baixar',
    coverFailed: 'Não foi possível carregar a capa — renderizando sem ela.',
  },
};

export default pt;
